var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{staticClass:"btn btn-block m-t-15 btn-lg btn-success waves-effect waves-light ladda-button",attrs:{"target":"_blank","href":_vm.cta_url},on:{"click":function($event){return _vm.openWhatsapp()}}},[_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"ladda-label"},[_vm._v("Entrar em contato por WhatsApp "),_c('i',{staticClass:"fab fa-whatsapp"})])
}]

export { render, staticRenderFns }